import React from 'react';
import "./AboutUsCard.css";

const AboutUsCards = ({ image, title, description, direction, index }) => {
  return <div data-aos="fade-up" className={ "aboutUsCardContainer" } style={{
    direction : direction===0 ? "ltr" : 'rtl',
    marginTop:index===0 ? 0 : 100
  }}>
    <div className={ "left_container" }>
      <h1>{ title }</h1>
      <p>{ description }</p>
    </div>
    <div className={ "right_content" }>
      <img src={ image } alt={ "myImage" }/>
    </div>
  </div>
}
export default AboutUsCards